document.querySelectorAll('.video-container').forEach(container => {
  const video = container.querySelector('video');
  const playBtn = container.querySelector('.bloco-video-thumb-play');

  playBtn.addEventListener('click', () => {
    video.play();
    playBtn.style.display = 'none';
    video.setAttribute('controls', 'true'); 
  });

  video.addEventListener('pause', () => {
    if (!video.seeking) {
      playBtn.style.display = 'flex'; 
    }
  });
});
